import PageIsLoadedTrigger from './trigger/page-is-loaded-trigger.js';

export function initialize() {
    PageIsLoadedTrigger.set();
}

export default {
    initialize
}
